import { InstallationStatus } from 'ta_utils/routes/gfap';

export default {
  landingPage: {
    footer: {
      privacy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      legalDisclosure: 'Legal Disclosure',
      copy: 'TA-Manager © 2025',
      followUs: 'Follow us on',
      linkedin: 'LinkedIn',
      twitter: 'Twitter',
      facebook: 'Facebook',
    },
    v2: {
      hero: {
        overline: 'Overcome in-house installation nightmares',
        title: 'Simplify Fiber Installations',
        subtitle1:
          "Customizable Branding: Tailor registration links, logos, and forms to reflect your ANP's identity.",
        subtitle2:
          'Effortless Integration: With a quick QR scan on the HFTP, installers access a fully personalized registration process.',
        subtitle3:
          'Enterprise-Grade Security & Real-Time Tracking: Benefit from secure, encrypted notifications and stay informed with immediate updates.',
        testimonialText:
          'TA-Manager transformed our onboarding—reducing installation times dramatically and enhancing customer satisfaction.',
        testimonialAuthor: 'Cable4',
      },
      keyFeatures: {
        title: 'Key Features',
        feature1: {
          title: 'Customizable Registration & Branding',
          description:
            'Personalize forms, logos, and redirect URLs to match your unique identity. Set up personalized flows for every customer!',
        },
        feature2: {
          title: 'Secure, Enterprise-Grade Integration',
          description:
            'Receive real-time, encrypted notifications. Safe, secure and reliable.',
        },
        feature3: {
          title: 'Efficient Installation Tracking',
          description:
            'Monitor every HFTP installation with detailed, real-time data and reporting.',
        },
        feature4: {
          title: 'Robust Form & Media Handling',
          description:
            'Supports signatures, images, and comprehensive form validation ensuring data accuracy.',
        },
        feature5: {
          title: 'Advanced Address Integration',
          description:
            'Associate installations with geolocation and address. Either using open data or bring your own database via API integration.',
        },
        feature6: {
          title: 'Industry-Leading in-house expertise',
          description:
            'TA-Manager is the result of the collaboration between KWS Electronic, the fiber optic technology specialist, and AND Solution GmbH, the industry leader in network level 4 documentation and planning.',
        },
      },
      steps: {
        title: 'Seamless Installations in 4 Easy Steps',
        step1: {
          title: 'Customize Your TA-Manager Profile',
          description:
            "In a brief onboarding session, we'll set up personalized registration links, logos, and form fields tailored specifically for you.",
        },
        step2: {
          title: 'Receive Your Personalized GF-TAs',
          description:
            'For each order, your custom GF-TAs are printed and delivered.',
        },
        step3: {
          title: 'Install the GF-TA & Scan the QR Code',
          description:
            'The installer mounts the GF-TA, scans the QR code, and initiates the tailored registration process.',
        },
        step4: {
          title: 'Receive Real-Time Updates',
          description:
            'Once submitted, secure webhooks notify your team instantly, triggering a personalized redirect.',
        },
      },
      whyChoose: {
        title: 'Why Access Network Providers Choose TA-Manager',
        point1:
          'Accelerated Onboarding: Automate registrations to drastically reduce manual data entry and installation delays.',
        point2:
          'Enterprise Support & Security: Premium support combined with industry-leading security, reliability, and GDPR compliance.',
        point3:
          "Tailored Customer Experience: Fully customizable forms and notifications that align with your ANP's brand and workflow.",
        point4:
          'Enhanced End-User Interaction: Simplify customer choices with smart redirects, pre-populated address selections, and intuitive interfaces.',
      },
      testimonials: {
        title: 'Testimonials',
        testimonial1: {
          testimonialText:
            'Manual registration was slow and error-prone. TA-Manager automated our onboarding process, slashing installation times significantly.',
          author: '[Customer Name]',
        },
        testimonial2: {
          testimonialText:
            'Customizing forms for various providers was overwhelming. Now we have dynamic, tailor-made forms for each ANP, and our operations run smoother than ever.',
          author: '[Customer Name]',
        },
        testimonial3: {
          testimonialText:
            "Tracking installations was chaotic until real-time notifications kept us fully informed, greatly improving our team's efficiency.",
          author: '[Customer Name]',
        },
        testimonial4: {
          testimonialText:
            'Our customers struggled with a confusing onboarding process. The branded, user-friendly registration transformed their experience, and customer satisfaction has soared.',
          author: '[Customer Name]',
        },
      },
      faqs: {
        title: 'Frequently Asked Questions',
        faq1: {
          question: 'What is TA-Manager?',
          answer:
            'It is a comprehensive hardware/software solution that prints custom registration links and logos onto GF-TAs to streamline the fiber installation process for network providers.',
        },
        faq2: {
          question: 'How does the QR code registration work?',
          answer:
            'Installers scan the QR code on the GF-TA, which launches a personalized registration form tailored to your network.',
        },
        faq3: {
          question: 'Is the solution secure and GDPR-compliant?',
          answer:
            'Absolutely—TA-Manager employs enterprise-grade security and adheres strictly to GDPR standards.',
        },
        faq4: {
          question: 'Can I customize forms and notifications?',
          answer:
            'Yes, you can fully customize forms, notifications, and the branding to match the requirements of your network provider.',
        },
      },
      cta: {
        title: 'Transform Your Business Today',
        subtitle:
          'Experience revolutionary network management that propels your business forward. Unlock exclusive insights, seamless integration, and actionable intelligence. Claim your free live demo now and step into the future!',
        button: 'Claim Your Live Demo',
      },
    },
  },
  common: {
    error: 'Error',
    loading: 'Loading...',
    notFound: 'Page not found',
    backToHome: 'Back to home',
    login: 'Login',
    logout: 'Logout',
    back: 'Back',
    home: 'Home',
    cancel: 'Cancel',
    admin_actions: 'Admin Actions',
    action_install: 'Install',
    action_not_ready: 'Not Ready',
    action_ready: 'Ready',
    installation_status: {
      installation: 'Installation',
      not_signal_ready: 'Not Signal Ready',
      operational: 'Operational',
    },
  },
  installation: {
    status: 'Installation Status',
    completed: 'Completed',
    pending: 'Pending',
    failed: 'Failed',
    installation: 'Installation',
    status_checked_at: 'Status checked at',
  },
  form: {
    providerLock: {
      formPassword: 'Please enter the form password',
      rateLimitExceeded: 'Too many attempts. Please try again later',
      errorOccurred: 'An error occurred. Please try again later',
      invalidCode: 'Invalid code. Please try again',
      enterAccessCode: 'Enter access code',
    },
    enterValue: 'Enter Value',
    submit: 'Submit',
    save: 'Save',
    reset: 'Reset',
    submissionSuccess: 'Successfully submitted',
    saveSuccess: 'Successfully saved',
    passwordExpired: 'Password expired',
    enterPassword: 'Enter password',
    redirecting: 'Redirecting in {seconds} seconds...',
    redirectingNow: 'Redirecting now...',
    cancelRedirect: 'Cancel redirect',
    submitting: 'Submitting...',
    submissionFailed: 'Error submitting form. Please try again.',
    missingRequiredFields: 'Please fill in all required fields',
    validation: {
      required: 'This field is required',
      invalidEmail: 'Invalid email address',
      minLength: 'Must be at least {min} characters',
    },
    address: {
      search: 'Search addresses...',
      id: 'ID',
      city: 'City',
      street: 'Street',
      zip: 'Zip',
      select: 'Select an address...',
      loading: 'Loading addresses...',
      noResults: 'No addresses found',
      error: {
        location: 'Could not get your location: {message}',
        geolocation: 'Geolocation is not supported by your browser',
        fetch: 'Failed to fetch addresses',
        distance: 'Error calculating distances',
      },
      noAddresses: 'No addresses found',
    },
    signature: {
      clear: 'Clear',
      edit: 'Edit',
      save: 'Save',
      loading: 'Loading...',
      description:
        'I hereby confirm that I have installed the customer access point in accordance with the installation instructions.',
      noSignature: 'No signature available',
    },
    select_option: 'Please select an option',
    enum: {
      installation: 'Installation',
      not_signal_ready: 'Installed but not signal ready',
      operational: 'Operational',
    },
    image: {
      clear: 'Clear image',
      choose: 'No file chosen',
    },
    fields: {
      installationStatus: 'Installation Status',
      password: 'Form password',
    },
    pdf: {
      installationReport: 'Installation Report',
      generatedOn: 'Generated on',
    },
    scanner: {
      scan: 'Scan',
    },
  },
  footer: {
    links: {
      privacyPolicy: {
        text: 'Privacy Policy',
      },
      termsOfService: {
        text: 'Terms of Service',
      },
      contactUs: {
        text: 'Contact Us',
      },
    },
  },
  report: {
    no_information: 'No information available',
    no_information_description:
      'For this connection, no information is currently available. Please try again at a later time.',
  },
  not_signal_ready: {
    title: 'Not activated',
    description:
      'Your connection is not activated yet. Please be patient while we process your activation.',
  },
  loading: {
    message: 'Loading, please wait...',
  },
  cookieConsent: {
    message: 'We use cookies to enhance your experience on our website.',
    learnMore: 'Learn More',
    policyLink: 'Privacy Policy',
    essentialOnly: 'Only Essential Cookies',
    acceptAll: 'Accept All Cookies',
  },
  locale: {
    chooseLanguage: 'Choose Language',
    selectLanguage: 'Select Language',
    languages: {
      en: 'English',
      de: 'German',
    },
  },
  dashboard: {
    create_batch_installations: 'Create a new batch of installations',
    list_and_manage_provisioned_installations:
      'List and manage operational installations',
    list_and_manage_reports: 'View all installations and their reports',
    list_and_manage_addresses: 'Browse and manage installation addresses',
  },
  site_names: {
    dashboard: 'Dashboard',
    create_batch: 'Create Batch',
    provisioned_installations: 'Provisioned Installations',
    reports: 'Reports',
    addresses: 'View Addresses',
    report: 'Report',
    login: 'Login',
  },
  create_batch: {
    quantity_label: 'Number of Codes to Generate',
    create: 'Create Batch',
    creating: 'Creating...',
    creation_success: 'Batch created successfully',
    download_csv: 'Download CSV',
    creation_error: 'Error creating batch',
    creation_error_description:
      'Please try again or contact support if the problem persists.',
  },
  provisioned: {
    provisioned_installations: 'Provisioned Installations',
    no_provisioned_installations: 'No provisioned installations available',
    no_provisioned_installations_description:
      'There are no provisioned installations available at the moment.',
    filter_show_all: 'Show all',
    filter_show_operational: 'Showing Only Operational',
    filter_show_not_signal_ready: 'Showing only Not Signal Ready',
    error_loading: 'An error occurred while loading data',
    error_getting_batches: 'Failed to get batch identifiers',
  },
  reports: {
    title: 'GFAP Reports',
    no_reports: 'No reports available',
    no_reports_description:
      'There are no GFAP reports available at the moment.',
    error_loading: 'An error occurred while loading data',
    error_updating_status: 'Failed to update installation status',
    error_batch_updating_status: 'Failed to update batch installation status',
    failed_updates: 'failed',
    selected: 'selected',
    batch_install: 'Mark All for Installation',
    batch_not_ready: 'Mark All Not Signal Ready',
    batch_ready: 'Mark All Operational',
    clear: 'Clear',
  },
  date_picker: {
    pick_a_date: 'Pick a date',
  },
  table_headers: {
    gfap_id: 'GFAP ID',
    created_at: 'Created at',
    activation_code: 'Activation Code',
    installation_transitioned_at: 'Transitioned at',
    street: 'Street',
    city: 'City',
  },
  filters: {
    address: 'Address',
    street: 'Street',
    city: 'City',
    date: 'Date',
    status: 'Status',
    search: 'Search',
    street_placeholder: 'Street...',
    city_placeholder: 'City...',
    zip_placeholder: 'ZIP...',
  },
  addresses: {
    title: 'View Addresses',
    no_addresses: 'No addresses found',
    no_addresses_description:
      'No addresses match your search criteria. Try a different search term.',
    add_address: 'Add Address',
    add_address_description:
      'Search for a location or click on the map to place a marker, then fill in the address details.',
    search_location: 'Search Location',
    search_placeholder: 'Enter an address to search...',
    map_hint:
      'Click on the map to place a marker, or drag the marker to adjust the position.',
    coordinates: 'Coordinates',
    geocoding_error: 'Failed to search for address. Please try again.',
    missing_fields:
      'Please fill in all required fields and place a marker on the map.',
    submit_error: 'Failed to add address. Please try again.',
    address_added: 'Address added successfully!',
    optional_auto_generated: 'optional, auto-generated if empty',
    id_placeholder: 'Custom ID or leave empty...',
  },
  installation_status: {
    [InstallationStatus.INSTALLATION]: 'Awaiting Installation',
    [InstallationStatus.NOT_SIGNAL_READY]: 'Not Signal Ready',
    [InstallationStatus.OPERATIONAL]: 'Operational',
  },
};
